import React from "react";

export const initialContext = {
  inputsValidated: true,
  customerError: "",
  selectedContracts: [], // ["id"]
  customerId: "",
}

export default React.createContext(initialContext);
